import BreakpointOnly from "./BreakpointOnly";
import Offcanvas from "bootstrap/js/src/offcanvas";

export default class MobileOffcanvas extends BreakpointOnly {
  constructor(breakpoint, el, options, trigger)
  {
    super(breakpoint);
    this.el = document.querySelector(el) || undefined;
    this.trigger = document.querySelector(trigger);
    this.elId = el;
    this.options = options;
    this.offcanvas = undefined;
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.closeWhen = this.closeWhen.bind(this);

    this.breakpointChecker();
  }

  enableOffcanvas()
  {
    this.offcanvas = new Offcanvas(this.el, this.options);

    if( this.trigger ) {
      this.trigger.addEventListener('click', this.show);
    }

    //Hide on mobile menu open

    document.addEventListener('mobile.menu.opened', this.hide);

    //Close other offcanvaces

    this.el.addEventListener('show.bs.offcanvas', event => {
      let Ev = new CustomEvent('filter.offcanvas.opened', {
        bubbles: false,
        detail: {
          elId: this.elId,
        }
      });

      document.dispatchEvent(Ev);
    });

    document.addEventListener('filter.offcanvas.opened', this.closeWhen);
  }

  closeWhen(event)
  {
    if( event.detail.elId !== this.elId ) {
      this.hide();
    }
  }

  mayBeDestroyOffcanvas()
  {
    if( this.offcanvas !== undefined  ) {
      this.offcanvas.dispose();
    }

    if( this.trigger ) {
      this.trigger.removeEventListener('click', this.show);
    }

    document.removeEventListener('mobile.menu.opened', this.hide);
    document.removeEventListener('filter.offcanvas.opened', this.closeWhen);
  }

  show()
  {
    if( this.offcanvas !== undefined  ) {
      this.offcanvas.show();
    }
  }

  hide()
  {
    if( this.offcanvas !== undefined  ) {
      this.offcanvas.hide();
    }
  }

  breakpointChecker()
  {
    if( ! this.el ) {
      return;
    }

    if ( this.breakpoint.matches === true ) {
      this.mayBeDestroyOffcanvas();
    } else {
      this.enableOffcanvas();
    }
  }
}
